// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"5a9ffad1","465":"69ca8cd3","535":"c20d6d3d","784":"22cfec0c"}[chunkId] + ".chunk.js";
};